import { EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AdministrationPermissions } from '@common/classes/permissions';
import { SignalrService } from '@common/services/signalr.service';
import { environment } from '@environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from '../../services/dialog.service';
import { UserService } from '../../services/user.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../../services/dialog.service";
import * as i3 from "@ngx-translate/core";
import * as i4 from "../../services/user.service";
import * as i5 from "@common/services/signalr.service";
import * as i6 from "ngx-toastr";
import * as i7 from "@angular/common";
import * as i8 from "@fortawesome/angular-fontawesome";
import * as i9 from "@ng-bootstrap/ng-bootstrap";
import * as i10 from "@progress/kendo-angular-navigation";
import * as i11 from "../notification/notification.component";
function HeaderComponent_img_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("src", ctx_r0.logo, i0.ɵɵsanitizeUrl);
  }
}
function HeaderComponent_h1_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngbTooltip", ctx_r1.version);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.title);
  }
}
function HeaderComponent_h1_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h1", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵattribute("style", ctx_r2.environmentColor, i0.ɵɵsanitizeStyle);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r2.environment);
  }
}
function HeaderComponent_kendo_appbar_section_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "kendo-appbar-section", 11);
    i0.ɵɵelement(1, "app-notification")(2, "span", 12);
    i0.ɵɵelementEnd();
  }
}
function HeaderComponent_kendo_appbar_section_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "kendo-appbar-section")(1, "span", 13);
    i0.ɵɵelement(2, "fa-icon", 14);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" \u00A0", ctx_r4.user.fullName ? ctx_r4.user.fullName : ctx_r4.user.userName, " ");
  }
}
function HeaderComponent_kendo_appbar_section_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "kendo-appbar-section")(1, "button", 1);
    i0.ɵɵlistener("click", function HeaderComponent_kendo_appbar_section_12_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r6 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r6.logout());
    });
    i0.ɵɵelement(2, "fa-icon", 15);
    i0.ɵɵelementEnd()();
  }
}
const _c0 = function () {
  return ["fas", "bars"];
};
export class HeaderComponent {
  constructor(router, dialogService, translateService, userService, signalrService, toastrService) {
    this.router = router;
    this.dialogService = dialogService;
    this.translateService = translateService;
    this.toastrService = toastrService;
    this.toggleSidebar = new EventEmitter();
    this.notifications = [];
    this.themeColor = environment.settings.header.themeColor;
    this.environment = environment.environment;
    this.environmentColor = environment.settings.header.environmentColor;
    this.version = environment.version;
    this.title = environment.settings.header.title;
    this.logo = environment.settings.header.logo;
    userService.currentUserSubject.subscribe(user => {
      this.user = user;
    });
    signalrService.notifications$.subscribe(notification => {
      this.notifications = [notification, ...this.notifications];
      this.toastrService[notification.type](this.translateService.instant(notification.message));
    });
  }
  onToggleSidebar() {
    this.toggleSidebar.emit();
  }
  login() {
    return this.router.navigate(['/login']);
  }
  logout() {
    this.dialogService.confirm(this.translateService.instant('Sign Out'), this.translateService.instant('Are you sure you want to sign out?')).then(result => {
      if (result === true) {
        this.router.navigate(['/logout']);
      }
    });
  }
  clearNotifications() {
    this.notifications = [];
  }
  isBellVisible() {
    return this.user?.hasPermission(AdministrationPermissions.Notification.view);
  }
}
HeaderComponent.ɵfac = function HeaderComponent_Factory(t) {
  return new (t || HeaderComponent)(i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(i2.DialogService), i0.ɵɵdirectiveInject(i3.TranslateService), i0.ɵɵdirectiveInject(i4.UserService), i0.ɵɵdirectiveInject(i5.SignalrService), i0.ɵɵdirectiveInject(i6.ToastrService));
};
HeaderComponent.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
  type: HeaderComponent,
  selectors: [["app-header"]],
  outputs: {
    toggleSidebar: "toggleSidebar"
  },
  decls: 13,
  vars: 9,
  consts: [["position", "top", "positionMode", "fixed", 1, "appbar", 3, "themeColor"], [1, "k-button", "k-button-clear", 3, "click"], [3, "icon"], ["style", "max-height: 32px; margin-right: 10px", 3, "src", 4, "ngIf"], ["class", "title", "placement", "bottom", "container", "body", 3, "ngbTooltip", 4, "ngIf"], ["class", "title", 4, "ngIf"], ["class", "actions", 4, "ngIf"], [4, "ngIf"], [2, "max-height", "32px", "margin-right", "10px", 3, "src"], ["placement", "bottom", "container", "body", 1, "title", 3, "ngbTooltip"], [1, "title"], [1, "actions"], [1, "k-appbar-separator"], [1, "name"], ["icon", "user"], ["icon", "arrow-right-from-bracket"]],
  template: function HeaderComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵelementStart(0, "kendo-appbar", 0)(1, "kendo-appbar-section")(2, "button", 1);
      i0.ɵɵlistener("click", function HeaderComponent_Template_button_click_2_listener() {
        return ctx.onToggleSidebar();
      });
      i0.ɵɵelement(3, "fa-icon", 2);
      i0.ɵɵelementEnd()();
      i0.ɵɵelementStart(4, "kendo-appbar-section");
      i0.ɵɵtemplate(5, HeaderComponent_img_5_Template, 1, 1, "img", 3);
      i0.ɵɵtemplate(6, HeaderComponent_h1_6_Template, 2, 2, "h1", 4);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(7, "kendo-appbar-section");
      i0.ɵɵtemplate(8, HeaderComponent_h1_8_Template, 2, 2, "h1", 5);
      i0.ɵɵelementEnd();
      i0.ɵɵelement(9, "kendo-appbar-spacer");
      i0.ɵɵtemplate(10, HeaderComponent_kendo_appbar_section_10_Template, 3, 0, "kendo-appbar-section", 6);
      i0.ɵɵtemplate(11, HeaderComponent_kendo_appbar_section_11_Template, 4, 1, "kendo-appbar-section", 7);
      i0.ɵɵtemplate(12, HeaderComponent_kendo_appbar_section_12_Template, 3, 0, "kendo-appbar-section", 7);
      i0.ɵɵelementEnd();
    }
    if (rf & 2) {
      i0.ɵɵproperty("themeColor", ctx.themeColor);
      i0.ɵɵadvance(3);
      i0.ɵɵproperty("icon", i0.ɵɵpureFunction0(8, _c0));
      i0.ɵɵadvance(2);
      i0.ɵɵproperty("ngIf", ctx.logo);
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.title);
      i0.ɵɵadvance(2);
      i0.ɵɵproperty("ngIf", ctx.environment);
      i0.ɵɵadvance(2);
      i0.ɵɵproperty("ngIf", ctx.isBellVisible());
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.user);
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("ngIf", ctx.user);
    }
  },
  dependencies: [i7.NgIf, i8.FaIconComponent, i9.NgbTooltip, i10.AppBarComponent, i10.AppBarSectionComponent, i10.AppBarSpacerComponent, i11.NotificationComponent],
  styles: [".appbar[_ngcontent-%COMP%] {\n  z-index: 1000;\n  box-shadow: 2px 0 10px 0 rgba(0, 0, 0, 0.45);\n  color: #fff;\n  overflow: visible;\n}\n\nbutton[_ngcontent-%COMP%]    > fa-icon[_ngcontent-%COMP%] {\n  color: #fff;\n}\nbutton[_ngcontent-%COMP%]    > fa-icon[_ngcontent-%COMP%]:hover {\n  color: #ddd;\n}\n\nkendo-badge-container[_ngcontent-%COMP%] {\n  margin-right: 8px;\n}\n\nul[_ngcontent-%COMP%] {\n  font-size: 14px;\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n}\nul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] {\n  margin: 0 9px;\n}\nul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:hover {\n  cursor: pointer;\n  color: #d6002f;\n}\n\nimg[_ngcontent-%COMP%] {\n  -moz-user-select: none;\n  -ms-user-select: none;\n  -webkit-user-select: none;\n}\n\n.title[_ngcontent-%COMP%] {\n  font-size: 18px;\n  margin: 0;\n}\n\n.name[_ngcontent-%COMP%] {\n  font-size: 1rem;\n}\n\n.actions[_ngcontent-%COMP%]   .k-button[_ngcontent-%COMP%] {\n  padding: 0;\n}\n\n.k-appbar[_ngcontent-%COMP%] {\n  padding: 6px;\n}\n\n.k-appbar-dark[_ngcontent-%COMP%] {\n  background-color: #343a3e !important;\n}\n.k-appbar-dark[_ngcontent-%COMP%]   .k-button-clear[_ngcontent-%COMP%] {\n  color: #fff;\n}\n.k-appbar-dark[_ngcontent-%COMP%]   .k-button-clear[_ngcontent-%COMP%]:hover {\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.k-icon[_ngcontent-%COMP%], fa-icon[_ngcontent-%COMP%] {\n  font-size: 1rem;\n}\n\n.k-appbar[_ngcontent-%COMP%]   .k-appbar-separator[_ngcontent-%COMP%] {\n  margin: 0 0.85rem 0 0.85rem;\n}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"]
});